import axiosHttp from "./interceptor.service";

export const getTodoTasks = (params) => {
    return axiosHttp.get("/getTodoTask", { params });
};

export const getTodoBoardTasks = (params) => {
    return axiosHttp.get("/getTodoBoardTasks", { params });
};

export const createTodoTask = (data) => {
    return axiosHttp.post("/createTodoTask", data);
};

export const updateTodoTask = (id, data) => {
    return axiosHttp.put(`/updateTodoTask/${id}`, data);
};

export const deleteTodoTask = (id) => {
    return axiosHttp.delete(`/deleteTodoTask/${id}`);
};

export const getTodoTaskById = (id) => {
    return axiosHttp.get(`/getTodoTaskById/${id}`);
};

export const getTaskActivityLog = (taskId, page = 1, limit = 20) => {
    return axiosHttp.get(`/getTaskActivityLog/${taskId}`, { params: { page, limit } });
};

export const getChildTasks = (taskId) => {
    return axiosHttp.get(`/getChildTasks/${taskId}`);
};

export const archiveTodoTask  = (id)     => axiosHttp.put(`/archiveTodoTask/${id}`);
export const restoreTodoTask  = (id)     => axiosHttp.put(`/restoreTodoTask/${id}`);
export const getArchivedTasks = (params) => axiosHttp.get("/getArchivedTodoTasks", { params });

export const getTaskNoPicker           = (params) => axiosHttp.get("/getTaskNoPicker", { params });
export const getPendingAcknowledgments = (params) => axiosHttp.get("/getPendingAcknowledgments", { params });
export const acknowledgeTodoTask       = (id)      => axiosHttp.put(`/acknowledgeTodoTask/${id}`);
export const requestReworkTodoTask     = (id, note) => axiosHttp.put(`/requestReworkTodoTask/${id}`, { note });

/**
 * Sets ONE assignee's own completion status on a task.
 * RBAC is enforced server-side: an assignee may change only their own line;
 * the creator (assignedBy), isAdmin and isOverAllAdmin may change anyone's.
 * The task-level `status` is recomputed as a rollup and returned in `data`,
 * so the caller can reconcile board columns.
 */
export const updateAssigneeStatus = (taskId, assigneeId, status) =>
    axiosHttp.put(`/updateTodoTaskAssigneeStatus/${taskId}`, { userId: assigneeId, status });

/** Adds/removes people on a task. Creator or admin only (enforced server-side). */
export const updateTaskAssignees = (taskId, { add, remove, assignees } = {}) =>
    axiosHttp.put(`/updateTodoTaskAssignees/${taskId}`, { add, remove, assignees });
